<script lang="ts">
  let { lines = 3 }: { lines?: number } = $props()
</script>

<div class="placeholder">
  {#each Array(lines) as _, idx}
    <div class="line" style={`--i:${idx}`}></div>
  {/each}
</div>

<style>
  .placeholder {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .line {
    height: 0.75rem;
    width: 100%;
    background: linear-gradient(90deg, #e5e7eb, #f3f4f6, #e5e7eb);
    border-radius: 9999px;
    animation: shimmer 1.2s infinite;
    animation-delay: calc(var(--i, 0) * 80ms);
  }

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
</style>
